import {objectFromEntries} from '@benchling/js-utils';
import reactUpdate from 'immutability-helper';

import {assertAndContinue} from 'Asserts';
import {
  ReplaceLinkStepKey,
  ORDERED_STEPS,
  ReplaceLinkModalReducerState,
  DiffDetails,
} from 'molbio/biointelligent-links/replace-link/constants';
import {StepItemStatus} from 'ui-library/StepNav';
import {assertNever} from 'util/Types';

interface UpdateCurrentStepAction {
  type: 'UPDATE_CURRENT_STEP';
  value: ReplaceLinkStepKey;
}

interface SetSelectedContainerPolymerIdsAction {
  type: 'SET_SELECTED_CONTAINER_POLYMER_IDS';
  value: Array<string>;
}

interface SetDiffDetailsAction {
  type: 'SET_DIFF_DETAILS';
  value: DiffDetails | null;
}

interface ToggleSidebarExpandedAction {
  type: 'TOGGLE_SIDEBAR_EXPANDED';
}

export type ReplaceLinkAction =
  | UpdateCurrentStepAction
  | SetSelectedContainerPolymerIdsAction
  | SetDiffDetailsAction
  | ToggleSidebarExpandedAction;

export default function replaceLinkReducer(
  state: ReplaceLinkModalReducerState,
  action: ReplaceLinkAction
): ReplaceLinkModalReducerState {
  switch (action.type) {
    case 'UPDATE_CURRENT_STEP': {
      const indexOfNewStep = ORDERED_STEPS.findIndex((step) => step === action.value);
      assertAndContinue(indexOfNewStep !== -1, `Got unexpected step: ${action.value}`);
      return reactUpdate(state, {
        currentStepKey: {$set: action.value},
        statusByStep: {
          $set: objectFromEntries(
            ORDERED_STEPS.map(
              (step: ReplaceLinkStepKey, index: number): [ReplaceLinkStepKey, StepItemStatus] => [
                step,
                index < indexOfNewStep ? StepItemStatus.DONE : StepItemStatus.UNVISITED,
              ]
            )
          ) as {[key in ReplaceLinkStepKey]: StepItemStatus},
        },
      });
    }
    case 'SET_SELECTED_CONTAINER_POLYMER_IDS': {
      return reactUpdate(state, {
        selectedContainerPolymerIds: {$set: action.value},
      });
    }
    case 'SET_DIFF_DETAILS': {
      return reactUpdate(state, {
        diffDetails: {$set: action.value},
      });
    }
    case 'TOGGLE_SIDEBAR_EXPANDED': {
      return reactUpdate(state, {
        sidebarExpanded: {$set: !state.sidebarExpanded},
      });
    }
    default:
      assertNever(action);
      return state;
  }
}
